import { render, staticRenderFns } from "./Review_config.vue?vue&type=template&id=7278184d"
import script from "./Review_config.vue?vue&type=script&lang=js"
export * from "./Review_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports